import { doorClient, ImResponse, resolve } from 'services/api';

interface PageParams {
  pageNum: number;
  pageSize: number;
}

export interface StoreSummaryListParams extends PageParams {
  keyword: string;
}

interface PageResponse {
  total: number;
  hasNext: number;
}

export interface StoreSummaryListResponse extends PageResponse {
  summaries: AeOverview.StoreSummary[];
}

export function storeSummaryList(params: StoreSummaryListParams) {
  return resolve(
    doorClient.get<ImResponse<StoreSummaryListResponse>>('/aggregation/v1/getAeUsageSummary', {
      params,
    }),
  );
}

export interface StoreMissListParams extends PageParams {
  storeId: string;
}

export interface StoreMissListResponse extends PageResponse {
  details: AeOverview.StoreMiss[];
}

export function storeMissList(params: StoreMissListParams) {
  return resolve(
    doorClient.get<ImResponse<StoreMissListResponse>>('/oversea-conversation/v1/getAeUsageDetail', {
      params: { ...params, result: 2 },
    }),
  );
}

export interface BuyerSummaryListParams extends PageParams {
  storeId: string;
  month: string | number;
}

export interface BuyerSummaryListResponse extends PageResponse {
  summaries: AeOverview.BuyerSummary[];
}

export function buyerSummaryList(params: BuyerSummaryListParams) {
  return resolve(
    doorClient.get<ImResponse<BuyerSummaryListResponse>>(
      '/oversea-conversation/v1/getAeServeBuyerSummary',
      { params },
    ),
  );
}

export interface BuyerDetailListParams extends PageParams {
  storeId: string;
  buyerId: string;
  month: string | number;
}

export interface BuyerDetailListResponse extends PageResponse {
  details: AeOverview.BuyerDetail[];
}

export function buyerDetailList(params: BuyerDetailListParams) {
  return resolve(
    doorClient.get<ImResponse<BuyerDetailListResponse>>(
      '/oversea-conversation/v1/getAeServeBuyerDetail',
      { params },
    ),
  );
}
